export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20spotlight%20rays%20cutting%20through%20darkness%2C%20abstract%20film%20texture%20and%20grain%2C%20elegant%20movie%20theater%20ambiance%2C%20dramatic%20light%20and%20shadow%20contrast%2C%20luxury%20cinema%20aesthetic%20in%20deep%20black%20and%20rich%20amber%20tones%2C%20wide%20cinematic%20composition%20with%20soft%20vignette%20edges&width=1600&height=900&seq=hero-bg-91movie&orientation=landscape"
          alt="91电影影院氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium tracking-wider mb-5 whitespace-nowrap">
              每日更新 · 免费观影
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              91电影 · 免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading mb-6">
              好片不停歇，精彩不花钱
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              91电影致力于打造国内领先的免费在线观影平台，每日精选最新国产电影免费大片与热门视频资源，覆盖动作、喜剧、悬疑、爱情等全类型影片。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              片库持续更新，播放流畅高清，无需注册、无需付费，随时随地畅享影视盛宴。本周已上新超过200部高清影片，热门专题持续策划中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-foreground-600 text-sm">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                每日更新 50+ 部
              </div>
              <div className="flex items-center gap-2 text-foreground-600 text-sm">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                高清流畅播放
              </div>
              <div className="flex items-center gap-2 text-foreground-600 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                全类型覆盖
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center"></i>
                立即探索专题
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-300 text-foreground-800 font-medium rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                查看热播排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-xl overflow-hidden shadow-[0_0_40px_rgba(245,158,11,0.15)]">
              <img
                src="https://readdy.ai/api/search-image?query=Golden%20film%20reel%20and%20movie%20clapperboard%20floating%20in%20dramatic%20spotlight%2C%20cinematic%20composition%20with%20warm%20amber%20glow%2C%20dark%20luxurious%20background%20with%20soft%20bokeh%20light%20particles%2C%20elegant%20movie%20poster%20style%2C%20rich%20contrast%20between%20golden%20light%20and%20deep%20shadows%2C%20premium%20film%20festival%20aesthetic&width=680&height=920&seq=hero-poster-91movie&orientation=portrait"
                alt="91电影主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <span className="text-primary-400 text-xs tracking-widest">SINCE 2024</span>
                <p className="text-foreground-950 font-heading text-lg mt-1">免费大片 · 即刻观看</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}